import api from '@/api'
import invoices from '@/api/apiSferest/services/invoices'
import transverser from '@/helpers/transverser'
import config from '@/utils/config'
import { timeoutPromise } from '@/utils/utils'
import { getUsername } from '@/utils/tokenUtils'
import { formatNowApi } from '@/helpers/formatDate'

export default {
  namespaced: true,
  state () {
    return {
      requestFactoringCheck: false,
      factoringOptionList: [],
      factoringOption: undefined,
      nif: null,
      name: null,
      surname: null,
      iban: null,
      phone: null,
      email: null,
      userIp: null,
      userPrivateIp: null,
      termsAgree: false,
      simulationResult: undefined
    }
  },
  mutations: {
    SET_NIF: (state, value) => {
      state.nif = value
    },
    SET_NAME: (state, value) => {
      state.name = value
    },
    SET_SURNAME: (state, value) => {
      state.surname = value
    },
    SET_IBAN: (state, value) => {
      state.iban = value
    },
    SET_PHONE: (state, value) => {
      state.phone = value
    },
    SET_EMAIL: (state, value) => {
      state.email = value
    },
    resetFactoring: (state) => {
      state.nif = null
      state.phone = null
      state.email = null
      state.name = null
      state.surname = null
      state.iban = null
      state.requestFactoringCheck = false
      state.termsAgree = false
      state.factoringOption = undefined
    },
    autoCheckFactoring: state => {
      state.requestFactoringCheck = true
    },
    factoringOption: (state, value) => {
      state.factoringOption = value
    },
    checkTerms: (state, value) => {
      state.termsAgree = value
    },
    simulationResult: (state, value) => {
      state.simulationResult = value
    }
  },
  actions: {
    fetchSelector: ({ state }, data) => {
      api.apiSferest.get(`selectors/promoters`, { data: {} }).then((res) => {
        switch (data) {
          case '9908':
            state.factoringOptionList = res.data
            .filter(promoter => promoter.id === '9908')
            break
          default:
            state.factoringOptionList = res.data
            .filter(promoter => promoter.id === '0001')
        }
      })
    },
    delayRequestFactoring: ({ state }, data) => {
      if (config.features.requestFactoring && state.requestFactoringCheck) {
        return timeoutPromise(config.features.requestFactoringEmitInvoiceDelay, data)
      } else {
        return Promise.resolve(data)
      }
    },
    getUserIp: ({ state }) => {
      fetch(config.urlApiUserIp)
        .then(res => res.json())
        .then((data) => {
          state.userIp = data.ip
        })
    },
    getUserPrivateIp: ({ state }) => {
      let ip = false
      window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection || false
      if (window.RTCPeerConnection) {
        ip = []
        // eslint-disable-next-line one-var
        let pc = new RTCPeerConnection({ iceServers: [] }), noop = function() {}
        pc.createDataChannel('')
        pc.createOffer(pc.setLocalDescription.bind(pc), noop)
        pc.onicecandidate = function(event) {
          if (event && event.candidate && event.candidate.candidate) {
            var s = event.candidate.candidate.split('\n')
            ip.push(s[0].split(' ')[4])
            if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ip[0])) {
              state.userPrivateIp = ip[0]
            } else state.userPrivateIp = 'not available'
          }
        }
      }
      if (!ip) state.userPrivateIp = 'not available'
    },
    simulateFinancing: ({ commit, dispatch, state }, params) => {
      return invoices.simulateFinancing(params)
      .then(res => {
        if (res.success) {
          state.simulationResult = res
        }
        return res
      })
      .catch(err => {
        throw err
      })
    },
    requestFactoring: ({ commit, dispatch, state }, data) => {
      let result = {
        previousData: data
      }
      let invoiceId = transverser.get('data.0.id')(data) // En caso de venir por alta
      let invoicesList = invoiceId ? [invoiceId] : data.invoiceSelectedList
      let username = getUsername()
      if (config.features.requestFactoring && state.termsAgree) {
        return invoices.requestFactoring({
          financer: {
            name: state.factoringOption.name,
            iban: state.iban ? state.iban.replace(/ /g, '') : null, // limpiado de espacios antes de enviar
            email: state.email,
            listId: invoicesList
          },
          financingSigner: {
            nif: state.nif,
            name: state.name,
            surname: state.surname,
            phone: state.phone
          },
          userInfo: {
            userRequested: username,
            publicIp: state.userIp,
            privateIp: state.userPrivateIp,
            soName: 'not available',
            timestamp: formatNowApi()
          }
        }).then(res => {
          result.result = res
          result.factoringError = false
          return Promise.resolve(result)
        }).catch(error => {
          if (data.ignoreErrors) {
            result.factoringError = true
            return Promise.resolve(result)
          } else {
            return Promise.reject(error)
          }
        })
      } else {
        return Promise.resolve(result)
      }
    }
  }
}
